// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Monad_Reader_Class from "../Control.Monad.Reader.Class/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Control_Monad_State from "../Control.Monad.State/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Control_Monad_State_Trans from "../Control.Monad.State.Trans/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_FunctorWithIndex from "../Data.FunctorWithIndex/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ord_Generic from "../Data.Ord.Generic/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Foliage_App_Style from "../Foliage.App.Style/index.js";
import * as Foliage_Common from "../Foliage.Common/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Record from "../Record/index.js";
var throwError = /* #__PURE__ */ Control_Monad_Error_Class.throwError(Control_Monad_Error_Class.monadThrowEither);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity));
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity));
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Control_Applicative.applicativeArray);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var foldMap = /* #__PURE__ */ Data_Array.foldMap(Data_Monoid.monoidArray);
var $$null = /* #__PURE__ */ Data_Foldable["null"](Data_List_Types.foldableList);
var map = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var functorReaderT = /* #__PURE__ */ Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity);
var map1 = /* #__PURE__ */ Data_Functor.map(functorReaderT);
var monoidReaderT = /* #__PURE__ */ Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray);
var fold = /* #__PURE__ */ Data_Array.fold(monoidReaderT);
var append2 = /* #__PURE__ */ Data_Semigroup.append(/* #__PURE__ */ Control_Monad_Reader_Trans.semigroupReaderT(Data_Identity.applyIdentity)(Data_Semigroup.semigroupArray));
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(monoidReaderT);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var intercalate = /* #__PURE__ */ Data_Array.intercalate(monoidReaderT);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var mapWithIndex = /* #__PURE__ */ Data_FunctorWithIndex.mapWithIndex(Data_Map_Internal.functorWithIndexMap);
var mapFlipped1 = /* #__PURE__ */ Data_Functor.mapFlipped(functorReaderT);
var ask = /* #__PURE__ */ Control_Monad_Reader_Class.ask(/* #__PURE__ */ Control_Monad_Reader_Trans.monadAskReaderT(Data_Identity.monadIdentity));
var show2 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Foliage_Common["_Show_Exc"]({
    reflectSymbol: function () {
        return "error";
    }
}));
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var fold1 = /* #__PURE__ */ Data_Foldable.fold(Data_List_Types.foldableList)(monoidReaderT);
var map3 = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var mapFlipped2 = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Maybe.functorMaybe);
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var genericShowSum = /* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "UnitLatticeType";
    }
}));
var SumLatticeTypeIsSymbol = {
    reflectSymbol: function () {
        return "SumLatticeType";
    }
};
var ProductLatticeTypeIsSymbol = {
    reflectSymbol: function () {
        return "ProductLatticeType";
    }
};
var SetLatticeTypeIsSymbol = {
    reflectSymbol: function () {
        return "SetLatticeType";
    }
};
var OppositeLatticeTypeIsSymbol = {
    reflectSymbol: function () {
        return "OppositeLatticeType";
    }
};
var FlatLatticeTypeIsSymbol = {
    reflectSymbol: function () {
        return "FlatLatticeType";
    }
};
var PowerLatticeTypeIsSymbol = {
    reflectSymbol: function () {
        return "PowerLatticeType";
    }
};
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var compare_implIsSymbol = {
    reflectSymbol: function () {
        return "compare_impl";
    }
};
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var genericShowSum1 = /* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "UnitDataType";
    }
}));
var SumDataTypeIsSymbol = {
    reflectSymbol: function () {
        return "SumDataType";
    }
};
var ProductDataTypeIsSymbol = {
    reflectSymbol: function () {
        return "ProductDataType";
    }
};
var SetDataTypeIsSymbol = {
    reflectSymbol: function () {
        return "SetDataType";
    }
};
var genericShowArgsArgument = /* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString);
var implIsSymbol = {
    reflectSymbol: function () {
        return "impl";
    }
};
var inputsIsSymbol = {
    reflectSymbol: function () {
        return "inputs";
    }
};
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons(nameIsSymbol);
var outputIsSymbol = {
    reflectSymbol: function () {
        return "output";
    }
};
var VarTermIsSymbol = {
    reflectSymbol: function () {
        return "VarTerm";
    }
};
var genericShowSum2 = /* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "UnitTerm";
    }
}));
var genericShowArgsProduct = /* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(genericShowArgsArgument);
var LeftTermIsSymbol = {
    reflectSymbol: function () {
        return "LeftTerm";
    }
};
var RightTermIsSymbol = {
    reflectSymbol: function () {
        return "RightTerm";
    }
};
var PairTermIsSymbol = {
    reflectSymbol: function () {
        return "PairTerm";
    }
};
var SetTermIsSymbol = {
    reflectSymbol: function () {
        return "SetTerm";
    }
};
var PropIsSymbol = {
    reflectSymbol: function () {
        return "Prop";
    }
};
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_Foldable.foldableArray);
var foldr = /* #__PURE__ */ Data_Foldable.foldr(Data_Foldable.foldableArray);
var foldMap1 = /* #__PURE__ */ Data_Foldable.foldMap(Data_Foldable.foldableArray);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableArray);
var foldl1 = /* #__PURE__ */ Data_Foldable.foldl(Data_List_Types.foldableList);
var foldr1 = /* #__PURE__ */ Data_Foldable.foldr(Data_List_Types.foldableList);
var foldMap2 = /* #__PURE__ */ Data_Foldable.foldMap(Data_List_Types.foldableList);
var traverse1 = /* #__PURE__ */ Data_Traversable.traverse(Data_List_Types.traversableList);
var genericEqArgument = /* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Data_Eq.eqString);
var genericEqProduct = /* #__PURE__ */ Data_Eq_Generic.genericEqProduct(genericEqArgument);
var bindStateT = /* #__PURE__ */ Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity);
var bind2 = /* #__PURE__ */ Control_Bind.bind(bindStateT);
var monadStateStateT = /* #__PURE__ */ Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity);
var get = /* #__PURE__ */ Control_Monad_State_Class.get(monadStateStateT);
var discard2 = /* #__PURE__ */ discard(bindStateT);
var modify_ = /* #__PURE__ */ Control_Monad_State_Class.modify_(monadStateStateT);
var applicativeStateT = /* #__PURE__ */ Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity);
var pure3 = /* #__PURE__ */ Control_Applicative.pure(applicativeStateT);
var mapFlipped3 = /* #__PURE__ */ Data_Functor.mapFlipped(Data_List_Types.functorList);
var genericEqConstructor = /* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments);
var genericEqSum = /* #__PURE__ */ Data_Eq_Generic.genericEqSum(genericEqConstructor);
var argsIsSymbol = {
    reflectSymbol: function () {
        return "args";
    }
};
var functionNameIsSymbol = {
    reflectSymbol: function () {
        return "functionName";
    }
};
var resultVarVarNameIsSymbol = {
    reflectSymbol: function () {
        return "resultVarVarName";
    }
};
var conclusionIsSymbol = {
    reflectSymbol: function () {
        return "conclusion";
    }
};
var hypothesesIsSymbol = {
    reflectSymbol: function () {
        return "hypotheses";
    }
};
var dataTypeDefsIsSymbol = {
    reflectSymbol: function () {
        return "dataTypeDefs";
    }
};
var docIsSymbol = {
    reflectSymbol: function () {
        return "doc";
    }
};
var functionDefsIsSymbol = {
    reflectSymbol: function () {
        return "functionDefs";
    }
};
var initialGasIsSymbol = {
    reflectSymbol: function () {
        return "initialGas";
    }
};
var latticeTypeDefsIsSymbol = {
    reflectSymbol: function () {
        return "latticeTypeDefs";
    }
};
var relationsIsSymbol = {
    reflectSymbol: function () {
        return "relations";
    }
};
var rulesIsSymbol = {
    reflectSymbol: function () {
        return "rules";
    }
};
var hypothesisIsSymbol = {
    reflectSymbol: function () {
        return "hypothesis";
    }
};
var rule$primeIsSymbol = {
    reflectSymbol: function () {
        return "rule'";
    }
};
var eqRec = /* #__PURE__ */ Data_Eq.eqRec();
var eqRowCons = /* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)();
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Data_Either.bindEither);
var pure4 = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(Data_Ord.ordString);
var VarName = /* #__PURE__ */ (function () {
    function VarName(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    VarName.create = function (value0) {
        return function (value1) {
            return new VarName(value0, value1);
        };
    };
    return VarName;
})();
var LeftGreaterThanRight_SumLatticeTypeOrdering = /* #__PURE__ */ (function () {
    function LeftGreaterThanRight_SumLatticeTypeOrdering() {

    };
    LeftGreaterThanRight_SumLatticeTypeOrdering.value = new LeftGreaterThanRight_SumLatticeTypeOrdering();
    return LeftGreaterThanRight_SumLatticeTypeOrdering;
})();
var LeftLessThanRight_SumLatticeTypeOrdering = /* #__PURE__ */ (function () {
    function LeftLessThanRight_SumLatticeTypeOrdering() {

    };
    LeftLessThanRight_SumLatticeTypeOrdering.value = new LeftLessThanRight_SumLatticeTypeOrdering();
    return LeftLessThanRight_SumLatticeTypeOrdering;
})();
var LeftIncomparableRight_SumLatticeTypeOrdering = /* #__PURE__ */ (function () {
    function LeftIncomparableRight_SumLatticeTypeOrdering() {

    };
    LeftIncomparableRight_SumLatticeTypeOrdering.value = new LeftIncomparableRight_SumLatticeTypeOrdering();
    return LeftIncomparableRight_SumLatticeTypeOrdering;
})();
var LeftEqualRight_SumLatticeTypeOrdering = /* #__PURE__ */ (function () {
    function LeftEqualRight_SumLatticeTypeOrdering() {

    };
    LeftEqualRight_SumLatticeTypeOrdering.value = new LeftEqualRight_SumLatticeTypeOrdering();
    return LeftEqualRight_SumLatticeTypeOrdering;
})();
var SetOrdering = /* #__PURE__ */ (function () {
    function SetOrdering() {

    };
    SetOrdering.value = new SetOrdering();
    return SetOrdering;
})();
var Raw = function (x) {
    return x;
};
var Punc = function (x) {
    return x;
};
var FirstThenSecond_ProductLatticeTypeOrdering = /* #__PURE__ */ (function () {
    function FirstThenSecond_ProductLatticeTypeOrdering() {

    };
    FirstThenSecond_ProductLatticeTypeOrdering.value = new FirstThenSecond_ProductLatticeTypeOrdering();
    return FirstThenSecond_ProductLatticeTypeOrdering;
})();
var Prim = function (x) {
    return x;
};
var Lit = function (x) {
    return x;
};
var FixedName = function (x) {
    return x;
};
var NamedLatticeType = /* #__PURE__ */ (function () {
    function NamedLatticeType(value0) {
        this.value0 = value0;
    };
    NamedLatticeType.create = function (value0) {
        return new NamedLatticeType(value0);
    };
    return NamedLatticeType;
})();
var UnitLatticeType = /* #__PURE__ */ (function () {
    function UnitLatticeType() {

    };
    UnitLatticeType.value = new UnitLatticeType();
    return UnitLatticeType;
})();
var SumLatticeType = /* #__PURE__ */ (function () {
    function SumLatticeType(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    SumLatticeType.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new SumLatticeType(value0, value1, value2);
            };
        };
    };
    return SumLatticeType;
})();
var ProductLatticeType = /* #__PURE__ */ (function () {
    function ProductLatticeType(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    ProductLatticeType.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new ProductLatticeType(value0, value1, value2);
            };
        };
    };
    return ProductLatticeType;
})();
var SetLatticeType = /* #__PURE__ */ (function () {
    function SetLatticeType(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SetLatticeType.create = function (value0) {
        return function (value1) {
            return new SetLatticeType(value0, value1);
        };
    };
    return SetLatticeType;
})();
var OppositeLatticeType = /* #__PURE__ */ (function () {
    function OppositeLatticeType(value0) {
        this.value0 = value0;
    };
    OppositeLatticeType.create = function (value0) {
        return new OppositeLatticeType(value0);
    };
    return OppositeLatticeType;
})();
var FlatLatticeType = /* #__PURE__ */ (function () {
    function FlatLatticeType(value0) {
        this.value0 = value0;
    };
    FlatLatticeType.create = function (value0) {
        return new FlatLatticeType(value0);
    };
    return FlatLatticeType;
})();
var PowerLatticeType = /* #__PURE__ */ (function () {
    function PowerLatticeType(value0) {
        this.value0 = value0;
    };
    PowerLatticeType.create = function (value0) {
        return new PowerLatticeType(value0);
    };
    return PowerLatticeType;
})();
var UnitDataType = /* #__PURE__ */ (function () {
    function UnitDataType() {

    };
    UnitDataType.value = new UnitDataType();
    return UnitDataType;
})();
var NamedDataType = /* #__PURE__ */ (function () {
    function NamedDataType(value0) {
        this.value0 = value0;
    };
    NamedDataType.create = function (value0) {
        return new NamedDataType(value0);
    };
    return NamedDataType;
})();
var SumDataType = /* #__PURE__ */ (function () {
    function SumDataType(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SumDataType.create = function (value0) {
        return function (value1) {
            return new SumDataType(value0, value1);
        };
    };
    return SumDataType;
})();
var ProductDataType = /* #__PURE__ */ (function () {
    function ProductDataType(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ProductDataType.create = function (value0) {
        return function (value1) {
            return new ProductDataType(value0, value1);
        };
    };
    return ProductDataType;
})();
var SetDataType = /* #__PURE__ */ (function () {
    function SetDataType(value0) {
        this.value0 = value0;
    };
    SetDataType.create = function (value0) {
        return new SetDataType(value0);
    };
    return SetDataType;
})();
var ExternalDataTypeDef = /* #__PURE__ */ (function () {
    function ExternalDataTypeDef(value0) {
        this.value0 = value0;
    };
    ExternalDataTypeDef.create = function (value0) {
        return new ExternalDataTypeDef(value0);
    };
    return ExternalDataTypeDef;
})();
var DataTypeDef = /* #__PURE__ */ (function () {
    function DataTypeDef(value0) {
        this.value0 = value0;
    };
    DataTypeDef.create = function (value0) {
        return new DataTypeDef(value0);
    };
    return DataTypeDef;
})();
var VarTerm = /* #__PURE__ */ (function () {
    function VarTerm(value0) {
        this.value0 = value0;
    };
    VarTerm.create = function (value0) {
        return new VarTerm(value0);
    };
    return VarTerm;
})();
var UnitTerm = /* #__PURE__ */ (function () {
    function UnitTerm() {

    };
    UnitTerm.value = new UnitTerm();
    return UnitTerm;
})();
var LiteralTerm = /* #__PURE__ */ (function () {
    function LiteralTerm(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    LiteralTerm.create = function (value0) {
        return function (value1) {
            return new LiteralTerm(value0, value1);
        };
    };
    return LiteralTerm;
})();
var LeftTerm = /* #__PURE__ */ (function () {
    function LeftTerm(value0) {
        this.value0 = value0;
    };
    LeftTerm.create = function (value0) {
        return new LeftTerm(value0);
    };
    return LeftTerm;
})();
var RightTerm = /* #__PURE__ */ (function () {
    function RightTerm(value0) {
        this.value0 = value0;
    };
    RightTerm.create = function (value0) {
        return new RightTerm(value0);
    };
    return RightTerm;
})();
var PairTerm = /* #__PURE__ */ (function () {
    function PairTerm(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    PairTerm.create = function (value0) {
        return function (value1) {
            return new PairTerm(value0, value1);
        };
    };
    return PairTerm;
})();
var SetTerm = /* #__PURE__ */ (function () {
    function SetTerm(value0) {
        this.value0 = value0;
    };
    SetTerm.create = function (value0) {
        return new SetTerm(value0);
    };
    return SetTerm;
})();
var Prop = /* #__PURE__ */ (function () {
    function Prop(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Prop.create = function (value0) {
        return function (value1) {
            return new Prop(value0, value1);
        };
    };
    return Prop;
})();
var FunctionSideHypothesis = /* #__PURE__ */ (function () {
    function FunctionSideHypothesis(value0) {
        this.value0 = value0;
    };
    FunctionSideHypothesis.create = function (value0) {
        return new FunctionSideHypothesis(value0);
    };
    return FunctionSideHypothesis;
})();
var Hypothesis = /* #__PURE__ */ (function () {
    function Hypothesis(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Hypothesis.create = function (value0) {
        return function (value1) {
            return new Hypothesis(value0, value1);
        };
    };
    return Hypothesis;
})();
var Rule = /* #__PURE__ */ (function () {
    function Rule(value0) {
        this.value0 = value0;
    };
    Rule.create = function (value0) {
        return new Rule(value0);
    };
    return Rule;
})();
var RipeRule = /* #__PURE__ */ (function () {
    function RipeRule(value0) {
        this.value0 = value0;
    };
    RipeRule.create = function (value0) {
        return new RipeRule(value0);
    };
    return RipeRule;
})();
var ExternalFunctionDef = /* #__PURE__ */ (function () {
    function ExternalFunctionDef(value0) {
        this.value0 = value0;
    };
    ExternalFunctionDef.create = function (value0) {
        return new ExternalFunctionDef(value0);
    };
    return ExternalFunctionDef;
})();
var LatticeTypeDef = /* #__PURE__ */ (function () {
    function LatticeTypeDef(value0) {
        this.value0 = value0;
    };
    LatticeTypeDef.create = function (value0) {
        return new LatticeTypeDef(value0);
    };
    return LatticeTypeDef;
})();
var ExternalLatticeTypeDef = /* #__PURE__ */ (function () {
    function ExternalLatticeTypeDef(value0) {
        this.value0 = value0;
    };
    ExternalLatticeTypeDef.create = function (value0) {
        return new ExternalLatticeTypeDef(value0);
    };
    return ExternalLatticeTypeDef;
})();
var Module = /* #__PURE__ */ (function () {
    function Module(value0) {
        this.value0 = value0;
    };
    Module.create = function (value0) {
        return new Module(value0);
    };
    return Module;
})();
var Relation = /* #__PURE__ */ (function () {
    function Relation(value0) {
        this.value0 = value0;
    };
    Relation.create = function (value0) {
        return new Relation(value0);
    };
    return Relation;
})();
var RenderCtx = function (x) {
    return x;
};
var throwExternalFunctionCallError = function (f) {
    return function (msg) {
        return throwError("when calling external function " + (f + (", " + msg)));
    };
};
var section = function (m_es) {
    return bind(m_es)(function (es) {
        return pure(pure1(Halogen_HTML_Elements.div([ Foliage_App_Style.style(append1(Foliage_App_Style.flex_column)(Foliage_App_Style.padding_horizontal_big)) ])(es)));
    });
};
var render = function (dict) {
    return dict.render;
};
var nextHypothesis = function (v) {
    if (v.value0.hypotheses instanceof Data_List_Types.Nil) {
        return new Data_Either.Left(v.value0.conclusion);
    };
    if (v.value0.hypotheses instanceof Data_List_Types.Cons) {
        return new Data_Either.Right(new RipeRule({
            hypothesis: v.value0.hypotheses.value0,
            "rule'": new Rule({
                conclusion: v.value0.conclusion,
                hypotheses: v.value0.hypotheses.value1
            })
        }));
    };
    throw new Error("Failed pattern match at Foliage.Program (line 245, column 30 - line 247, column 110): " + [ v.value0.hypotheses.constructor.name ]);
};
var newVarName = function (s) {
    return new VarName(s, 0);
};
var mainModuleName = "Main";
var lookupModule = function (dictIsSymbol) {
    var get1 = Record.get(dictIsSymbol);
    return function (dictCons) {
        var get2 = get1(dictCons);
        return function (dictOrd) {
            var lookup3 = Data_Map_Internal.lookup(dictOrd);
            return function (label) {
                return function (k) {
                    var $1353 = lookup3(k);
                    var $1354 = get2(label);
                    return function ($1355) {
                        return $1353($1354((function (v) {
                            return v.value0;
                        })($1355)));
                    };
                };
            };
        };
    };
};
var line = function (m_es) {
    return bind(m_es)(function (es) {
        return pure(pure1(Halogen_HTML_Elements.span([  ])(foldMap(function (e) {
            return [ e, Halogen_HTML_Elements.span([ Foliage_App_Style.style([ "white-space: pre" ]) ])([ Halogen_HTML_Core.text(" ") ]) ];
        })(es))));
    });
};
var from_RipeRule_to_Rule = function (v) {
    return new Rule({
        hypotheses: new Data_List_Types.Cons(v.value0.hypothesis, v["value0"]["rule'"].value0.hypotheses),
        conclusion: v["value0"]["rule'"].value0.conclusion
    });
};
var fromNoHypothesesRule = function (v) {
    var $939 = $$null(v.value0.hypotheses);
    if ($939) {
        return new Data_Maybe.Just(v.value0.conclusion);
    };
    return Data_Maybe.Nothing.value;
};
var freshVarNameIndexRef = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(/* #__PURE__ */ Effect_Ref["new"](0));
var freshenVarName = function (v) {
    return Effect_Unsafe.unsafePerformEffect(function __do() {
        var n = map(function (i) {
            return new VarName(v.value0, i);
        })(Effect_Ref.read(freshVarNameIndexRef))();
        Effect_Ref.modify_(function (v1) {
            return v1 + 1 | 0;
        })(freshVarNameIndexRef)();
        return n;
    });
};
var doc_block = function (s) {
    return pure([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(append1(Foliage_App_Style.padding_small)(append1(Foliage_App_Style.font_prose)([ "max-width: 30em", "background-color: rgba(0, 0, 0, 0.1)", "white-space: pre-wrap" ]))) ])([ Halogen_HTML_Core.text(s) ]) ]);
};
var divs = function (props) {
    var $1356 = map1((function () {
        var $1358 = Halogen_HTML_Elements.div(props);
        return function ($1359) {
            return pure1($1358($1359));
        };
    })());
    return function ($1357) {
        return $1356(fold($1357));
    };
};
var append_render = function (dictRender) {
    var render7 = render(dictRender);
    return function (a) {
        return append2(render7(a));
    };
};
var _Show_FixedName = Data_Show.showString;
var genericShowArgsArgument1 = /* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(_Show_FixedName);
var genericShowConstructor1 = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(genericShowArgsArgument1);
var genericShowSum3 = /* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1({
    reflectSymbol: function () {
        return "NamedLatticeType";
    }
}));
var genericShowSum4 = /* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1({
    reflectSymbol: function () {
        return "NamedDataType";
    }
}));
var genericShowArgsProduct1 = /* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(genericShowArgsArgument1);
var showMap = /* #__PURE__ */ Data_Map_Internal.showMap(_Show_FixedName);
var _Render_VarName = {
    render: function (v) {
        if (v.value1 === 0) {
            return pure(pure1(Halogen_HTML_Elements.span([ Foliage_App_Style.style([ "color: darkgreen" ]) ])([ Halogen_HTML_Core.text(v.value0) ])));
        };
        return pure(pure1(Halogen_HTML_Elements.span([ Foliage_App_Style.style([ "color: darkgreen" ]) ])([ Halogen_HTML_Core.text(v.value0), Halogen_HTML_Elements.sub([ Foliage_App_Style.style([ "color: gray" ]) ])([ Halogen_HTML_Core.text(show(v.value1)) ]) ])));
    }
};
var append_render1 = /* #__PURE__ */ append_render(_Render_VarName);
var _Render_RenderM_Htmls = {
    render: identity
};
var append_render2 = /* #__PURE__ */ append_render(_Render_RenderM_Htmls);
var _Render_Raw = {
    render: function (v) {
        return pure([ Halogen_HTML_Elements.span([ Foliage_App_Style.style([ "color: blue" ]) ])([ Halogen_HTML_Core.text(v) ]) ]);
    }
};
var append_render3 = /* #__PURE__ */ append_render(_Render_Raw);
var _Render_Punc = {
    render: function (v) {
        return pure(pure1(Halogen_HTML_Elements.span([ Foliage_App_Style.style(append1(Foliage_App_Style.bold)([ "color: black" ])) ])([ Halogen_HTML_Core.text(v) ])));
    }
};
var append_render4 = /* #__PURE__ */ append_render(_Render_Punc);
var render1 = /* #__PURE__ */ render(_Render_Punc);
var definition = function (mb_doc) {
    return function (m_sort) {
        return function (m_name) {
            return function (m_body) {
                return divs([ Foliage_App_Style.style(append1(Foliage_App_Style.flex_column)(append1(Foliage_App_Style.padding_small)(Foliage_App_Style.boundaries))) ])([ Data_Maybe.maybe(mempty)(map1((function () {
                    var $1360 = Halogen_HTML_Elements.div([  ]);
                    return function ($1361) {
                        return pure1($1360($1361));
                    };
                })()))(mb_doc), line(append_render2(m_sort)(append_render2(m_name)(append_render4("=")(mempty)))), section(m_body) ]);
            };
        };
    };
};
var _Render_Prim = {
    render: function (v) {
        return pure(pure1(Halogen_HTML_Elements.span([ Foliage_App_Style.style([ "color: purple" ]) ])([ Halogen_HTML_Core.text(v) ])));
    }
};
var append_render5 = /* #__PURE__ */ append_render(_Render_Prim);
var _Render_Lit = {
    render: function (v) {
        return pure([ Halogen_HTML_Elements.span([ Foliage_App_Style.style(append1(Foliage_App_Style.italic)([ "color: brown" ])) ])([ Halogen_HTML_Core.text(v) ]) ]);
    }
};
var append_render6 = /* #__PURE__ */ append_render(_Render_Lit);
var _Render_Term = {
    render: function (v) {
        if (v instanceof VarTerm) {
            return append_render1(v.value0)(mempty);
        };
        if (v instanceof LiteralTerm && (v.value1 instanceof NamedDataType && v.value1.value0 === "String")) {
            return append_render6(show1(v.value0))(mempty);
        };
        if (v instanceof LiteralTerm) {
            return append_render6(v.value0)(mempty);
        };
        if (v instanceof UnitTerm) {
            return append_render5("\u25cf")(mempty);
        };
        if (v instanceof LeftTerm) {
            return append_render4("(")(append_render5("\u261c")(append_render(_Render_Term)(v.value0)(append_render4(")")(mempty))));
        };
        if (v instanceof RightTerm) {
            return append_render4("(")(append_render5("\u261e")(append_render(_Render_Term)(v.value0)(append_render4(")")(mempty))));
        };
        if (v instanceof PairTerm) {
            return append_render4("\u27e8")(append_render(_Render_Term)(v.value0)(append_render4(",")(append_render(_Render_Term)(v.value1)(append_render4("\u27e9")(mempty)))));
        };
        if (v instanceof SetTerm) {
            return append_render4("{")(append_render2(intercalate(append_render4(",")(mempty))(mapFlipped(v.value0)(render(_Render_Term))))(append_render4("}")(mempty)));
        };
        throw new Error("Failed pattern match at Foliage.Program (line 664, column 12 - line 672, column 107): " + [ v.constructor.name ]);
    }
};
var append_render7 = /* #__PURE__ */ append_render(_Render_Term);
var render2 = /* #__PURE__ */ render(_Render_Term);
var _Render_TermSubst = {
    render: function (m) {
        return (function (es) {
            return append_render4("{")(append_render2(es)(append_render4("}")(mempty)));
        })(intercalate(append_render4(",")(mempty))(fromFoldable(Data_Map_Internal.values(mapWithIndex(function (x) {
            return function (t) {
                return append_render1(x)(append_render4("\u21a6")(append_render7(t)(mempty)));
            };
        })(m)))));
    }
};
var _Render_Htmls = {
    render: pure
};
var _Render_FixedName = {
    render: function (v) {
        return pure(pure1(Halogen_HTML_Elements.span([ Foliage_App_Style.style([ "color: #808000" ]) ])([ Halogen_HTML_Core.text(v) ])));
    }
};
var append_render8 = /* #__PURE__ */ append_render(_Render_FixedName);
var render3 = /* #__PURE__ */ render(_Render_FixedName);
var _Render_LatticeType = {
    render: function (v) {
        if (v instanceof NamedLatticeType) {
            return append_render8(v.value0)(mempty);
        };
        if (v instanceof UnitLatticeType) {
            return append_render5("Unit")(mempty);
        };
        if (v instanceof SumLatticeType) {
            var sup = (function () {
                if (v.value0 instanceof LeftGreaterThanRight_SumLatticeTypeOrdering) {
                    return "L>R";
                };
                if (v.value0 instanceof LeftLessThanRight_SumLatticeTypeOrdering) {
                    return "L<R";
                };
                if (v.value0 instanceof LeftIncomparableRight_SumLatticeTypeOrdering) {
                    return "L\u22c8R";
                };
                if (v.value0 instanceof LeftEqualRight_SumLatticeTypeOrdering) {
                    return "L=R";
                };
                throw new Error("Failed pattern match at Foliage.Program (line 579, column 13 - line 583, column 55): " + [ v.value0.constructor.name ]);
            })();
            var plus_sup = mapFlipped1(append_render4("+")(pure([ Halogen_HTML_Elements.sup([  ])([ Halogen_HTML_Core.text(sup) ]) ])))((function () {
                var $1362 = Halogen_HTML_Elements.span([  ]);
                return function ($1363) {
                    return pure1($1362($1363));
                };
            })());
            return append_render4("(")(append_render(_Render_LatticeType)(v.value1)(append_render2(plus_sup)(append_render(_Render_LatticeType)(v.value2)(append_render4(")")(mempty)))));
        };
        if (v instanceof ProductLatticeType) {
            var prod_sup = mapFlipped1(append_render4("\xd7")(pure([ Halogen_HTML_Elements.sup([  ])([ Halogen_HTML_Core.text("1,2") ]) ])))((function () {
                var $1364 = Halogen_HTML_Elements.span([  ]);
                return function ($1365) {
                    return pure1($1364($1365));
                };
            })());
            return append_render4("(")(append_render(_Render_LatticeType)(v.value1)(append_render2(prod_sup)(append_render(_Render_LatticeType)(v.value2)(append_render4(")")(mempty)))));
        };
        if (v instanceof SetLatticeType) {
            return append_render5("Set")(append_render4("(")(append_render(_Render_LatticeType)(v.value1)(append_render4(")")(mempty))));
        };
        if (v instanceof OppositeLatticeType) {
            return append_render5("Opposite")(append_render4("(")(append_render(_Render_LatticeType)(v.value0)(append_render4(")")(mempty))));
        };
        if (v instanceof FlatLatticeType) {
            return append_render5("Flat")(append_render4("(")(append_render(_Render_LatticeType)(v.value0)(append_render4(")")(mempty))));
        };
        if (v instanceof PowerLatticeType) {
            return append_render5("Power")(append_render4("(")(append_render(_Render_LatticeType)(v.value0)(append_render4(")")(mempty))));
        };
        throw new Error("Failed pattern match at Foliage.Program (line 571, column 12 - line 594, column 74): " + [ v.constructor.name ]);
    }
};
var append_render9 = /* #__PURE__ */ append_render(_Render_LatticeType);
var _Render_SideHypothesis = {
    render: function (v) {
        return append_render4("let")(append_render1(v.value0.resultVarVarName)(append_render4("=")(append_render8(v.value0.functionName)(append_render4("(")(append_render2(intercalate(append_render4(",")(mempty))(mapFlipped(v.value0.args)(render2)))(append_render4(")")(mempty)))))));
    }
};
var render4 = /* #__PURE__ */ render(_Render_SideHypothesis);
var _Render_DataType = {
    render: function (v) {
        if (v instanceof NamedDataType) {
            return append_render8(v.value0)(mempty);
        };
        if (v instanceof UnitDataType) {
            return append_render5("Unit")(mempty);
        };
        if (v instanceof SumDataType) {
            return append_render4("(")(append_render(_Render_DataType)(v.value0)(append_render4("+")(append_render(_Render_DataType)(v.value1)(append_render4(")")(mempty)))));
        };
        if (v instanceof SetDataType) {
            return append_render5("Set")(append_render(_Render_DataType)(v.value0)(mempty));
        };
        if (v instanceof ProductDataType) {
            return append_render4("(")(append_render(_Render_DataType)(v.value0)(append_render4("*")(append_render(_Render_DataType)(v.value1)(append_render4(")")(mempty)))));
        };
        throw new Error("Failed pattern match at Foliage.Program (line 597, column 12 - line 602, column 75): " + [ v.constructor.name ]);
    }
};
var append_render10 = /* #__PURE__ */ append_render(_Render_DataType);
var _Ord_FixedName = Data_Ord.ordString;
var lookup1 = /* #__PURE__ */ Foliage_Common.lookup(_Ord_FixedName)(/* #__PURE__ */ Control_Monad_Except_Trans.monadThrowExceptT(Data_Identity.monadIdentity))(_Show_FixedName);
var _Render_Prop = {
    render: function (v) {
        return bind(ask)(function (v1) {
            return bind(Data_Either.either(function (exc) {
                return Partial_Unsafe.unsafeCrashWith(show2(exc));
            })(pure)(Control_Monad_Except.runExcept(lookup1("relations")(v.value0)(v1.mod.value0.relations))))(function (v2) {
                return v2.value0.render(v.value1);
            });
        });
    }
};
var append_render11 = /* #__PURE__ */ append_render(_Render_Prop);
var _Render_Hypothesis = {
    render: function (v) {
        return append_render2(line(append_render11(v.value0)(mempty)))(append_render2(fold(map2(function ($1366) {
            return line(render4($1366));
        })(v.value1)))(mempty));
    }
};
var render5 = /* #__PURE__ */ render(_Render_Hypothesis);
var _Render_Rule = {
    render: function (v) {
        return bind(line(append_render11(v.value0.conclusion)(mempty)))(function (conclusion) {
            return bind(fold1(map3(render5)(v.value0.hypotheses)))(function (hypotheses) {
                return pure([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.flex_column) ])((function () {
                    var $1002 = Data_List["null"](v.value0.hypotheses);
                    if ($1002) {
                        return conclusion;
                    };
                    return Data_Array.concat([ hypotheses, [ Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.horizontal_bar) ])([  ]) ], conclusion ]);
                })()) ]);
            });
        });
    }
};
var render6 = /* #__PURE__ */ render(_Render_Rule);
var _Render_Module = {
    render: function (v) {
        return definition(mapFlipped2(v.value0.doc)(doc_block))(render1("module"))(render3(v.value0.name))((function () {
            var renderModDefinition = function (label) {
                return function (renderBody) {
                    return function (items) {
                        return fold(fromFoldable(Data_Map_Internal.values(mapWithIndex(function (name) {
                            return function (body) {
                                return definition(Data_Maybe.Nothing.value)(label)(render3(name))(renderBody(body));
                            };
                        })(items))));
                    };
                };
            };
            return fold([ renderModDefinition(append_render4("data type")(mempty))(function (v1) {
                if (v1 instanceof DataTypeDef) {
                    return line(append_render10(v1.value0)(mempty));
                };
                if (v1 instanceof ExternalDataTypeDef) {
                    return line(append_render4("external")(append_render3(v1.value0)(mempty)));
                };
                throw new Error("Failed pattern match at Foliage.Program (line 520, column 65 - line 522, column 87): " + [ v1.constructor.name ]);
            })(v.value0.dataTypeDefs), renderModDefinition(append_render4("function")(mempty))(function (v1) {
                return line(append_render4("external")(append_render3(v1.value0.name)(append_render4("(")(append_render2(intercalate(append_render4(",")(mempty))(mapFlipped(v1.value0.inputs)(function (v2) {
                    return append_render3(v2.value0)(append_render4(":")(append_render10(v2.value1)(mempty)));
                })))(append_render4(")")(append_render4("\u2192")(append_render10(v1.value0.output)(mempty))))))));
            })(v.value0.functionDefs), renderModDefinition(append_render4("partially ordered type")(mempty))(function (v1) {
                if (v1 instanceof LatticeTypeDef) {
                    return line(append_render9(v1.value0)(mempty));
                };
                if (v1 instanceof ExternalLatticeTypeDef) {
                    return line(append_render4("external")(append_render3(v1.value0.name)(mempty)));
                };
                throw new Error("Failed pattern match at Foliage.Program (line 527, column 78 - line 529, column 95): " + [ v1.constructor.name ]);
            })(v.value0.latticeTypeDefs), renderModDefinition(append_render4("relation")(mempty))(function (v1) {
                return bind(line(append_render4("domain:")(append_render9(v1.value0.domain)(mempty))))(function (verbose) {
                    return bind(line(append_render4("notation:")(v1.value0.render(v1.value0.canonical_term))))(function (pretty) {
                        return pure([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.flex_column) ])([ Halogen_HTML_Elements.div([  ])(verbose), Halogen_HTML_Elements.div([  ])(pretty) ]) ]);
                    });
                });
            })(v.value0.relations), renderModDefinition(append_render4("rule")(mempty))(function (rule) {
                return map1((function () {
                    var $1367 = Halogen_HTML_Elements.div([ Foliage_App_Style.style([ "display: inline-flex", "flex-direction: row" ]) ]);
                    return function ($1368) {
                        return pure1($1367($1368));
                    };
                })())(render6(rule));
            })(v.value0.rules) ]);
        })());
    }
};
var _Newtype_FixedName = {
    Coercible0: function () {
        return undefined;
    }
};
var _Generic_VarName = {
    to: function (x) {
        return new VarName(x.value0, x.value1);
    },
    from: function (x) {
        return new Data_Generic_Rep.Product(x.value0, x.value1);
    }
};
var _Generic_TermF = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new VarTerm(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return UnitTerm.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new LiteralTerm(x.value0.value0.value0.value0, x.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new LeftTerm(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new RightTerm(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return new PairTerm(x.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
            return new SetTerm(x.value0.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Foliage.Program (line 336, column 1 - line 336, column 54): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof VarTerm) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof UnitTerm) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof LiteralTerm) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))));
        };
        if (x instanceof LeftTerm) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof RightTerm) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof PairTerm) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1)))))));
        };
        if (x instanceof SetTerm) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))));
        };
        throw new Error("Failed pattern match at Foliage.Program (line 336, column 1 - line 336, column 54): " + [ x.constructor.name ]);
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_TermF);
var genericEq = /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_TermF);
var _Generic_SumLatticeTypeOrdering = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return LeftGreaterThanRight_SumLatticeTypeOrdering.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return LeftLessThanRight_SumLatticeTypeOrdering.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return LeftIncomparableRight_SumLatticeTypeOrdering.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return LeftEqualRight_SumLatticeTypeOrdering.value;
        };
        throw new Error("Failed pattern match at Foliage.Program (line 130, column 1 - line 130, column 84): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof LeftGreaterThanRight_SumLatticeTypeOrdering) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof LeftLessThanRight_SumLatticeTypeOrdering) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof LeftIncomparableRight_SumLatticeTypeOrdering) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof LeftEqualRight_SumLatticeTypeOrdering) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Foliage.Program (line 130, column 1 - line 130, column 84): " + [ x.constructor.name ]);
    }
};
var genericShow1 = /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_SumLatticeTypeOrdering)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "LeftGreaterThanRight_SumLatticeTypeOrdering";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "LeftLessThanRight_SumLatticeTypeOrdering";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "LeftIncomparableRight_SumLatticeTypeOrdering";
    }
}))(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "LeftEqualRight_SumLatticeTypeOrdering";
    }
})))));
var genericEq1 = /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_SumLatticeTypeOrdering)(/* #__PURE__ */ genericEqSum(/* #__PURE__ */ genericEqSum(/* #__PURE__ */ genericEqSum(genericEqConstructor))));
var _Show_SumLatticeTypeOrdering = {
    show: function (x) {
        return genericShow1(x);
    }
};
var genericShowArgsProduct2 = /* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(_Show_SumLatticeTypeOrdering));
var _Generic_SideHypothesisF = {
    to: function (x) {
        return new FunctionSideHypothesis(x);
    },
    from: function (x) {
        return x.value0;
    }
};
var _Generic_SetOrdering = {
    to: function (x) {
        return SetOrdering.value;
    },
    from: function (x) {
        return Data_Generic_Rep.NoArguments.value;
    }
};
var genericShow2 = /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_SetOrdering)(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "SetOrdering";
    }
}));
var genericEq2 = /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_SetOrdering)(genericEqConstructor);
var _Show_SetOrdering = {
    show: function (x) {
        return genericShow2(x);
    }
};
var genericShowArgsProduct3 = /* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(_Show_SetOrdering));
var _Generic_RuleF = {
    to: function (x) {
        return new Rule(x);
    },
    from: function (x) {
        return x.value0;
    }
};
var _Generic_RipeRuleF = {
    to: function (x) {
        return new RipeRule(x);
    },
    from: function (x) {
        return x.value0;
    }
};
var _Generic_Relation = {
    to: function (x) {
        return new Relation(x);
    },
    from: function (x) {
        return x.value0;
    }
};
var _Generic_PropF = {
    to: function (x) {
        return new Prop(x.value0, x.value1);
    },
    from: function (x) {
        return new Data_Generic_Rep.Product(x.value0, x.value1);
    }
};
var genericShow3 = /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_PropF);
var genericEq3 = /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_PropF);
var _Generic_ProductLatticeTypeOrdering = {
    to: function (x) {
        return FirstThenSecond_ProductLatticeTypeOrdering.value;
    },
    from: function (x) {
        return Data_Generic_Rep.NoArguments.value;
    }
};
var genericShow4 = /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_ProductLatticeTypeOrdering)(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "FirstThenSecond_ProductLatticeTypeOrdering";
    }
}));
var genericEq4 = /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_ProductLatticeTypeOrdering)(genericEqConstructor);
var _Show_ProductLatticeTypeOrdering = {
    show: function (x) {
        return genericShow4(x);
    }
};
var genericShowArgsProduct4 = /* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(_Show_ProductLatticeTypeOrdering));
var _Generic_Module = {
    to: function (x) {
        return new Module(x);
    },
    from: function (x) {
        return x.value0;
    }
};
var _Generic_LatticeTypeDef = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new LatticeTypeDef(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new ExternalLatticeTypeDef(x.value0);
        };
        throw new Error("Failed pattern match at Foliage.Program (line 98, column 1 - line 98, column 68): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof LatticeTypeDef) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof ExternalLatticeTypeDef) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Foliage.Program (line 98, column 1 - line 98, column 68): " + [ x.constructor.name ]);
    }
};
var _Generic_LatticeType = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new NamedLatticeType(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return UnitLatticeType.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new SumLatticeType(x.value0.value0.value0.value0, x.value0.value0.value0.value1.value0, x.value0.value0.value0.value1.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new ProductLatticeType(x.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value1.value0, x.value0.value0.value0.value0.value1.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new SetLatticeType(x.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return new OppositeLatticeType(x.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return new FlatLatticeType(x.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))) {
            return new PowerLatticeType(x.value0.value0.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Foliage.Program (line 116, column 1 - line 116, column 62): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof NamedLatticeType) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof UnitLatticeType) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof SumLatticeType) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2)))));
        };
        if (x instanceof ProductLatticeType) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, new Data_Generic_Rep.Product(x.value1, x.value2))))));
        };
        if (x instanceof SetLatticeType) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))))));
        };
        if (x instanceof OppositeLatticeType) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
        };
        if (x instanceof FlatLatticeType) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))));
        };
        if (x instanceof PowerLatticeType) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)))))));
        };
        throw new Error("Failed pattern match at Foliage.Program (line 116, column 1 - line 116, column 62): " + [ x.constructor.name ]);
    }
};
var genericShow5 = /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_LatticeType);
var genericEq5 = /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_LatticeType);
var _Show_LatticeType = {
    show: function (x) {
        return genericShow5(genericShowSum3(genericShowSum(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(genericShowArgsProduct2(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(_Show_LatticeType))(Data_Show_Generic.genericShowArgsArgument(_Show_LatticeType))))(SumLatticeTypeIsSymbol))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(genericShowArgsProduct4(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(_Show_LatticeType))(Data_Show_Generic.genericShowArgsArgument(_Show_LatticeType))))(ProductLatticeTypeIsSymbol))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(genericShowArgsProduct3(Data_Show_Generic.genericShowArgsArgument(_Show_LatticeType)))(SetLatticeTypeIsSymbol))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(_Show_LatticeType))(OppositeLatticeTypeIsSymbol))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(_Show_LatticeType))(FlatLatticeTypeIsSymbol))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(_Show_LatticeType))(PowerLatticeTypeIsSymbol)))))))))(x);
    }
};
var genericShow6 = /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_LatticeTypeDef)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(_Show_LatticeType))({
    reflectSymbol: function () {
        return "LatticeTypeDef";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(compare_implIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(nameIsSymbol)(Data_Show.showString))(/* #__PURE__ */ Foliage_Common["_Show_Opaque"]({
    reflectSymbol: function () {
        return "compare";
    }
})))))({
    reflectSymbol: function () {
        return "ExternalLatticeTypeDef";
    }
})));
var show3 = /* #__PURE__ */ Data_Show.show(_Show_LatticeType);
var _Show_LatticeTypeDef = {
    show: function (x) {
        return genericShow6(x);
    }
};
var _Show_Relation = {
    show: function (v) {
        return "(Relation " + (show3(v.value0.domain) + ")");
    }
};
var _Generic_HypothesisF = {
    to: function (x) {
        return new Hypothesis(x.value0, x.value1);
    },
    from: function (x) {
        return new Data_Generic_Rep.Product(x.value0, x.value1);
    }
};
var _Generic_FunctionDef = {
    to: function (x) {
        return new ExternalFunctionDef(x);
    },
    from: function (x) {
        return x.value0;
    }
};
var _Generic_DataTypeDef = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new ExternalDataTypeDef(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new DataTypeDef(x.value0);
        };
        throw new Error("Failed pattern match at Foliage.Program (line 68, column 1 - line 68, column 62): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ExternalDataTypeDef) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof DataTypeDef) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Foliage.Program (line 68, column 1 - line 68, column 62): " + [ x.constructor.name ]);
    }
};
var _Generic_DataType = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return UnitDataType.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new NamedDataType(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new SumDataType(x.value0.value0.value0.value0, x.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new ProductDataType(x.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
            return new SetDataType(x.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Foliage.Program (line 83, column 1 - line 83, column 56): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof UnitDataType) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof NamedDataType) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof SumDataType) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))));
        };
        if (x instanceof ProductDataType) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1)))));
        };
        if (x instanceof SetDataType) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))));
        };
        throw new Error("Failed pattern match at Foliage.Program (line 83, column 1 - line 83, column 56): " + [ x.constructor.name ]);
    }
};
var genericShow7 = /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_DataType);
var genericEq6 = /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_DataType);
var _Show_DataType = {
    show: function (x) {
        return genericShow7(genericShowSum1(genericShowSum4(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(_Show_DataType))(Data_Show_Generic.genericShowArgsArgument(_Show_DataType)))(SumDataTypeIsSymbol))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(_Show_DataType))(Data_Show_Generic.genericShowArgsArgument(_Show_DataType)))(ProductDataTypeIsSymbol))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(_Show_DataType))(SetDataTypeIsSymbol))))))(x);
    }
};
var genericShowArgsArgument2 = /* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(_Show_DataType);
var genericShow8 = /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_DataTypeDef)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(genericShowArgsArgument)({
    reflectSymbol: function () {
        return "ExternalDataTypeDef";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(genericShowArgsArgument2)({
    reflectSymbol: function () {
        return "DataTypeDef";
    }
})));
var genericShow9 = /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_FunctionDef)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(implIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(inputsIsSymbol)(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(outputIsSymbol)(_Show_DataType))(Data_Show.showString))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple.showTuple(Data_Show.showString)(_Show_DataType))))(/* #__PURE__ */ Foliage_Common["_Show_Opaque"]({
    reflectSymbol: function () {
        return "function";
    }
})))))({
    reflectSymbol: function () {
        return "ExternalFunctionDef";
    }
}));
var genericShowSum5 = /* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ genericShowArgsProduct(genericShowArgsArgument2))({
    reflectSymbol: function () {
        return "LiteralTerm";
    }
}));
var _Show_DataTypeDef = {
    show: function (x) {
        return genericShow8(x);
    }
};
var _Show_FunctionDef = {
    show: function (x) {
        return genericShow9(x);
    }
};
var _Show_Term = function (dictShow) {
    var genericShowSum6 = Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))(VarTermIsSymbol));
    return {
        show: function (x) {
            return genericShow(genericShowSum6(genericShowSum2(genericShowSum5(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(_Show_Term(dictShow)))(LeftTermIsSymbol))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(_Show_Term(dictShow)))(RightTermIsSymbol))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(_Show_Term(dictShow)))(Data_Show_Generic.genericShowArgsArgument(_Show_Term(dictShow))))(PairTermIsSymbol))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showArray(_Show_Term(dictShow))))(SetTermIsSymbol))))))))(x);
        }
    };
};
var _Show_PropF = function (dictShow) {
    var genericShow15 = genericShow3(Data_Show_Generic.genericShowConstructor(genericShowArgsProduct1(Data_Show_Generic.genericShowArgsArgument(_Show_Term(dictShow))))(PropIsSymbol));
    return {
        show: function (x) {
            return genericShow15(x);
        }
    };
};
var _Functor_TermF = {
    map: function (f) {
        return function (m) {
            if (m instanceof VarTerm) {
                return new VarTerm(f(m.value0));
            };
            if (m instanceof UnitTerm) {
                return UnitTerm.value;
            };
            if (m instanceof LiteralTerm) {
                return new LiteralTerm(m.value0, m.value1);
            };
            if (m instanceof LeftTerm) {
                return new LeftTerm(Data_Functor.map(_Functor_TermF)(f)(m.value0));
            };
            if (m instanceof RightTerm) {
                return new RightTerm(Data_Functor.map(_Functor_TermF)(f)(m.value0));
            };
            if (m instanceof PairTerm) {
                return new PairTerm(Data_Functor.map(_Functor_TermF)(f)(m.value0), Data_Functor.map(_Functor_TermF)(f)(m.value1));
            };
            if (m instanceof SetTerm) {
                return new SetTerm(map2(Data_Functor.map(_Functor_TermF)(f))(m.value0));
            };
            throw new Error("Failed pattern match at Foliage.Program (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
        };
    }
};
var map4 = /* #__PURE__ */ Data_Functor.map(_Functor_TermF);
var _Functor_SideHypothesisF = {
    map: function (f) {
        return function (m) {
            return new FunctionSideHypothesis({
                functionName: m.value0.functionName,
                args: map2(map4(f))(m.value0.args),
                resultVarVarName: f(m.value0.resultVarVarName)
            });
        };
    }
};
var map5 = /* #__PURE__ */ Data_Functor.map(_Functor_SideHypothesisF);
var _Functor_PropF = {
    map: function (f) {
        return function (m) {
            return new Prop(m.value0, map4(f)(m.value1));
        };
    }
};
var map6 = /* #__PURE__ */ Data_Functor.map(_Functor_PropF);
var _Functor_HypothesisF = {
    map: function (f) {
        return function (m) {
            return new Hypothesis(map6(f)(m.value0), map2(map5(f))(m.value1));
        };
    }
};
var map7 = /* #__PURE__ */ Data_Functor.map(_Functor_HypothesisF);
var _Functor_RuleF = {
    map: function (f) {
        return function (m) {
            return new Rule({
                conclusion: map6(f)(m.value0.conclusion),
                hypotheses: map3(map7(f))(m.value0.hypotheses)
            });
        };
    }
};
var map8 = /* #__PURE__ */ Data_Functor.map(_Functor_RuleF);
var _Functor_RipeRuleF = {
    map: function (f) {
        return function (m) {
            return new RipeRule({
                hypothesis: map7(f)(m.value0.hypothesis),
                "rule'": map8(f)(m["value0"]["rule'"])
            });
        };
    }
};
var _Foldable_TermF = {
    foldl: function (f) {
        return function (z) {
            return function (m) {
                if (m instanceof VarTerm) {
                    return f(z)(m.value0);
                };
                if (m instanceof UnitTerm) {
                    return z;
                };
                if (m instanceof LiteralTerm) {
                    return z;
                };
                if (m instanceof LeftTerm) {
                    return Data_Foldable.foldl(_Foldable_TermF)(f)(z)(m.value0);
                };
                if (m instanceof RightTerm) {
                    return Data_Foldable.foldl(_Foldable_TermF)(f)(z)(m.value0);
                };
                if (m instanceof PairTerm) {
                    return Data_Foldable.foldl(_Foldable_TermF)(f)(Data_Foldable.foldl(_Foldable_TermF)(f)(z)(m.value0))(m.value1);
                };
                if (m instanceof SetTerm) {
                    return foldl(Data_Foldable.foldl(_Foldable_TermF)(f))(z)(m.value0);
                };
                throw new Error("Failed pattern match at Foliage.Program (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
            };
        };
    },
    foldr: function (f) {
        return function (z) {
            return function (m) {
                if (m instanceof VarTerm) {
                    return f(m.value0)(z);
                };
                if (m instanceof UnitTerm) {
                    return z;
                };
                if (m instanceof LiteralTerm) {
                    return z;
                };
                if (m instanceof LeftTerm) {
                    return Data_Foldable.foldr(_Foldable_TermF)(f)(z)(m.value0);
                };
                if (m instanceof RightTerm) {
                    return Data_Foldable.foldr(_Foldable_TermF)(f)(z)(m.value0);
                };
                if (m instanceof PairTerm) {
                    return Data_Foldable.foldr(_Foldable_TermF)(f)(Data_Foldable.foldr(_Foldable_TermF)(f)(z)(m.value1))(m.value0);
                };
                if (m instanceof SetTerm) {
                    return foldr(Data_Function.flip(Data_Foldable.foldr(_Foldable_TermF)(f)))(z)(m.value0);
                };
                throw new Error("Failed pattern match at Foliage.Program (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
            };
        };
    },
    foldMap: function (dictMonoid) {
        var mempty1 = Data_Monoid.mempty(dictMonoid);
        var append3 = Data_Semigroup.append(dictMonoid.Semigroup0());
        var foldMap8 = foldMap1(dictMonoid);
        return function (f) {
            return function (m) {
                if (m instanceof VarTerm) {
                    return f(m.value0);
                };
                if (m instanceof UnitTerm) {
                    return mempty1;
                };
                if (m instanceof LiteralTerm) {
                    return mempty1;
                };
                if (m instanceof LeftTerm) {
                    return Data_Foldable.foldMap(_Foldable_TermF)(dictMonoid)(f)(m.value0);
                };
                if (m instanceof RightTerm) {
                    return Data_Foldable.foldMap(_Foldable_TermF)(dictMonoid)(f)(m.value0);
                };
                if (m instanceof PairTerm) {
                    return append3(Data_Foldable.foldMap(_Foldable_TermF)(dictMonoid)(f)(m.value0))(Data_Foldable.foldMap(_Foldable_TermF)(dictMonoid)(f)(m.value1));
                };
                if (m instanceof SetTerm) {
                    return foldMap8(Data_Foldable.foldMap(_Foldable_TermF)(dictMonoid)(f))(m.value0);
                };
                throw new Error("Failed pattern match at Foliage.Program (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
            };
        };
    }
};
var foldl2 = /* #__PURE__ */ Data_Foldable.foldl(_Foldable_TermF);
var foldr2 = /* #__PURE__ */ Data_Foldable.foldr(_Foldable_TermF);
var foldMap3 = /* #__PURE__ */ Data_Foldable.foldMap(_Foldable_TermF);
var _Traversable_TermF = {
    traverse: function (dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map9 = Data_Functor.map(Apply0.Functor0());
        var pure5 = Control_Applicative.pure(dictApplicative);
        var apply = Control_Apply.apply(Apply0);
        var traverse7 = traverse(dictApplicative);
        return function (f) {
            return function (m) {
                if (m instanceof VarTerm) {
                    return map9(function (v1) {
                        return new VarTerm(v1);
                    })(f(m.value0));
                };
                if (m instanceof UnitTerm) {
                    return pure5(UnitTerm.value);
                };
                if (m instanceof LiteralTerm) {
                    return pure5(new LiteralTerm(m.value0, m.value1));
                };
                if (m instanceof LeftTerm) {
                    return map9(function (v1) {
                        return new LeftTerm(v1);
                    })(Data_Traversable.traverse(_Traversable_TermF)(dictApplicative)(f)(m.value0));
                };
                if (m instanceof RightTerm) {
                    return map9(function (v1) {
                        return new RightTerm(v1);
                    })(Data_Traversable.traverse(_Traversable_TermF)(dictApplicative)(f)(m.value0));
                };
                if (m instanceof PairTerm) {
                    return apply(map9(function (v2) {
                        return function (v3) {
                            return new PairTerm(v2, v3);
                        };
                    })(Data_Traversable.traverse(_Traversable_TermF)(dictApplicative)(f)(m.value0)))(Data_Traversable.traverse(_Traversable_TermF)(dictApplicative)(f)(m.value1));
                };
                if (m instanceof SetTerm) {
                    return map9(function (v1) {
                        return new SetTerm(v1);
                    })(traverse7(Data_Traversable.traverse(_Traversable_TermF)(dictApplicative)(f))(m.value0));
                };
                throw new Error("Failed pattern match at Foliage.Program (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
            };
        };
    },
    sequence: function (dictApplicative) {
        return function (v) {
            return Data_Traversable.traverse(_Traversable_TermF)(dictApplicative)(identity)(v);
        };
    },
    Functor0: function () {
        return _Functor_TermF;
    },
    Foldable1: function () {
        return _Foldable_TermF;
    }
};
var traverse2 = /* #__PURE__ */ Data_Traversable.traverse(_Traversable_TermF);
var _Foldable_SideHypothesisF = {
    foldl: function (f) {
        return function (z) {
            return function (m) {
                return f(foldl(foldl2(f))(z)(m.value0.args))(m.value0.resultVarVarName);
            };
        };
    },
    foldr: function (f) {
        return function (z) {
            return function (m) {
                return foldr(Data_Function.flip(foldr2(f)))(f(m.value0.resultVarVarName)(z))(m.value0.args);
            };
        };
    },
    foldMap: function (dictMonoid) {
        var append3 = Data_Semigroup.append(dictMonoid.Semigroup0());
        var foldMap8 = foldMap1(dictMonoid);
        var foldMap9 = foldMap3(dictMonoid);
        return function (f) {
            return function (m) {
                return append3(foldMap8(foldMap9(f))(m.value0.args))(f(m.value0.resultVarVarName));
            };
        };
    }
};
var foldl3 = /* #__PURE__ */ Data_Foldable.foldl(_Foldable_SideHypothesisF);
var foldr3 = /* #__PURE__ */ Data_Foldable.foldr(_Foldable_SideHypothesisF);
var foldMap4 = /* #__PURE__ */ Data_Foldable.foldMap(_Foldable_SideHypothesisF);
var _Traversable_SideHypothesisF = {
    traverse: function (dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = Control_Apply.apply(Apply0);
        var map9 = Data_Functor.map(Apply0.Functor0());
        var traverse7 = traverse(dictApplicative);
        var traverse8 = traverse2(dictApplicative);
        return function (f) {
            return function (m) {
                return apply(map9(function (v1) {
                    return function (v2) {
                        return new FunctionSideHypothesis({
                            functionName: m.value0.functionName,
                            args: v1,
                            resultVarVarName: v2
                        });
                    };
                })(traverse7(traverse8(f))(m.value0.args)))(f(m.value0.resultVarVarName));
            };
        };
    },
    sequence: function (dictApplicative) {
        return function (v) {
            return Data_Traversable.traverse(_Traversable_SideHypothesisF)(dictApplicative)(identity)(v);
        };
    },
    Functor0: function () {
        return _Functor_SideHypothesisF;
    },
    Foldable1: function () {
        return _Foldable_SideHypothesisF;
    }
};
var traverse3 = /* #__PURE__ */ Data_Traversable.traverse(_Traversable_SideHypothesisF);
var _Foldable_PropF = {
    foldl: function (f) {
        return function (z) {
            return function (m) {
                return foldl2(f)(z)(m.value1);
            };
        };
    },
    foldr: function (f) {
        return function (z) {
            return function (m) {
                return foldr2(f)(z)(m.value1);
            };
        };
    },
    foldMap: function (dictMonoid) {
        var foldMap8 = foldMap3(dictMonoid);
        return function (f) {
            return function (m) {
                return foldMap8(f)(m.value1);
            };
        };
    }
};
var foldl4 = /* #__PURE__ */ Data_Foldable.foldl(_Foldable_PropF);
var foldr4 = /* #__PURE__ */ Data_Foldable.foldr(_Foldable_PropF);
var foldMap5 = /* #__PURE__ */ Data_Foldable.foldMap(_Foldable_PropF);
var _Traversable_PropF = {
    traverse: function (dictApplicative) {
        var map9 = Data_Functor.map((dictApplicative.Apply0()).Functor0());
        var traverse7 = traverse2(dictApplicative);
        return function (f) {
            return function (m) {
                return map9(function (v2) {
                    return new Prop(m.value0, v2);
                })(traverse7(f)(m.value1));
            };
        };
    },
    sequence: function (dictApplicative) {
        return function (v) {
            return Data_Traversable.traverse(_Traversable_PropF)(dictApplicative)(identity)(v);
        };
    },
    Functor0: function () {
        return _Functor_PropF;
    },
    Foldable1: function () {
        return _Foldable_PropF;
    }
};
var traverse4 = /* #__PURE__ */ Data_Traversable.traverse(_Traversable_PropF);
var _Foldable_HypothesisF = {
    foldl: function (f) {
        return function (z) {
            return function (m) {
                return foldl(foldl3(f))(foldl4(f)(z)(m.value0))(m.value1);
            };
        };
    },
    foldr: function (f) {
        return function (z) {
            return function (m) {
                return foldr4(f)(foldr(Data_Function.flip(foldr3(f)))(z)(m.value1))(m.value0);
            };
        };
    },
    foldMap: function (dictMonoid) {
        var append3 = Data_Semigroup.append(dictMonoid.Semigroup0());
        var foldMap8 = foldMap5(dictMonoid);
        var foldMap9 = foldMap1(dictMonoid);
        var foldMap10 = foldMap4(dictMonoid);
        return function (f) {
            return function (m) {
                return append3(foldMap8(f)(m.value0))(foldMap9(foldMap10(f))(m.value1));
            };
        };
    }
};
var foldl5 = /* #__PURE__ */ Data_Foldable.foldl(_Foldable_HypothesisF);
var foldr5 = /* #__PURE__ */ Data_Foldable.foldr(_Foldable_HypothesisF);
var foldMap6 = /* #__PURE__ */ Data_Foldable.foldMap(_Foldable_HypothesisF);
var _Foldable_RuleF = {
    foldl: function (f) {
        return function (z) {
            return function (m) {
                return foldl1(foldl5(f))(foldl4(f)(z)(m.value0.conclusion))(m.value0.hypotheses);
            };
        };
    },
    foldr: function (f) {
        return function (z) {
            return function (m) {
                return foldr4(f)(foldr1(Data_Function.flip(foldr5(f)))(z)(m.value0.hypotheses))(m.value0.conclusion);
            };
        };
    },
    foldMap: function (dictMonoid) {
        var append3 = Data_Semigroup.append(dictMonoid.Semigroup0());
        var foldMap8 = foldMap5(dictMonoid);
        var foldMap9 = foldMap2(dictMonoid);
        var foldMap10 = foldMap6(dictMonoid);
        return function (f) {
            return function (m) {
                return append3(foldMap8(f)(m.value0.conclusion))(foldMap9(foldMap10(f))(m.value0.hypotheses));
            };
        };
    }
};
var foldl6 = /* #__PURE__ */ Data_Foldable.foldl(_Foldable_RuleF);
var foldr6 = /* #__PURE__ */ Data_Foldable.foldr(_Foldable_RuleF);
var foldMap7 = /* #__PURE__ */ Data_Foldable.foldMap(_Foldable_RuleF);
var _Foldable_RipeRuleF = {
    foldl: function (f) {
        return function (z) {
            return function (m) {
                return foldl6(f)(foldl5(f)(z)(m.value0.hypothesis))(m["value0"]["rule'"]);
            };
        };
    },
    foldr: function (f) {
        return function (z) {
            return function (m) {
                return foldr5(f)(foldr6(f)(z)(m["value0"]["rule'"]))(m.value0.hypothesis);
            };
        };
    },
    foldMap: function (dictMonoid) {
        var append3 = Data_Semigroup.append(dictMonoid.Semigroup0());
        var foldMap8 = foldMap6(dictMonoid);
        var foldMap9 = foldMap7(dictMonoid);
        return function (f) {
            return function (m) {
                return append3(foldMap8(f)(m.value0.hypothesis))(foldMap9(f)(m["value0"]["rule'"]));
            };
        };
    }
};
var _Traversable_HypothesisF = {
    traverse: function (dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = Control_Apply.apply(Apply0);
        var map9 = Data_Functor.map(Apply0.Functor0());
        var traverse7 = traverse4(dictApplicative);
        var traverse8 = traverse(dictApplicative);
        var traverse9 = traverse3(dictApplicative);
        return function (f) {
            return function (m) {
                return apply(map9(function (v2) {
                    return function (v3) {
                        return new Hypothesis(v2, v3);
                    };
                })(traverse7(f)(m.value0)))(traverse8(traverse9(f))(m.value1));
            };
        };
    },
    sequence: function (dictApplicative) {
        return function (v) {
            return Data_Traversable.traverse(_Traversable_HypothesisF)(dictApplicative)(identity)(v);
        };
    },
    Functor0: function () {
        return _Functor_HypothesisF;
    },
    Foldable1: function () {
        return _Foldable_HypothesisF;
    }
};
var traverse5 = /* #__PURE__ */ Data_Traversable.traverse(_Traversable_HypothesisF);
var _Traversable_RuleF = {
    traverse: function (dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = Control_Apply.apply(Apply0);
        var map9 = Data_Functor.map(Apply0.Functor0());
        var traverse7 = traverse4(dictApplicative);
        var traverse8 = traverse1(dictApplicative);
        var traverse9 = traverse5(dictApplicative);
        return function (f) {
            return function (m) {
                return apply(map9(function (v1) {
                    return function (v2) {
                        return new Rule({
                            conclusion: v1,
                            hypotheses: v2
                        });
                    };
                })(traverse7(f)(m.value0.conclusion)))(traverse8(traverse9(f))(m.value0.hypotheses));
            };
        };
    },
    sequence: function (dictApplicative) {
        return function (v) {
            return Data_Traversable.traverse(_Traversable_RuleF)(dictApplicative)(identity)(v);
        };
    },
    Functor0: function () {
        return _Functor_RuleF;
    },
    Foldable1: function () {
        return _Foldable_RuleF;
    }
};
var traverse6 = /* #__PURE__ */ Data_Traversable.traverse(_Traversable_RuleF);
var _Traversable_RipeRuleF = {
    traverse: function (dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = Control_Apply.apply(Apply0);
        var map9 = Data_Functor.map(Apply0.Functor0());
        var traverse7 = traverse5(dictApplicative);
        var traverse8 = traverse6(dictApplicative);
        return function (f) {
            return function (m) {
                return apply(map9(function (v1) {
                    return function (v2) {
                        return new RipeRule({
                            hypothesis: v1,
                            "rule'": v2
                        });
                    };
                })(traverse7(f)(m.value0.hypothesis)))(traverse8(f)(m["value0"]["rule'"]));
            };
        };
    },
    sequence: function (dictApplicative) {
        return function (v) {
            return Data_Traversable.traverse(_Traversable_RipeRuleF)(dictApplicative)(identity)(v);
        };
    },
    Functor0: function () {
        return _Functor_RipeRuleF;
    },
    Foldable1: function () {
        return _Foldable_RipeRuleF;
    }
};
var _Eq_VarName = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_VarName)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ genericEqProduct(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Data_Eq.eqInt))))
};
var _Ord_VarName = {
    compare: /* #__PURE__ */ Data_Ord_Generic.genericCompare(_Generic_VarName)(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdProduct(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(Data_Ord.ordString))(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(Data_Ord.ordInt)))),
    Eq0: function () {
        return _Eq_VarName;
    }
};
var lookup2 = /* #__PURE__ */ Data_Map_Internal.lookup(_Ord_VarName);
var insert = /* #__PURE__ */ Data_Map_Internal.insert(_Ord_VarName);
var freshenVarNames = function (dictShow) {
    return function (dictTraversable) {
        var traverse7 = Data_Traversable.traverse(dictTraversable)(applicativeStateT);
        return function (t) {
            var f = function (x) {
                return bind2(get)(function (sigma) {
                    var v = lookup2(x)(sigma);
                    if (v instanceof Data_Maybe.Nothing) {
                        var y = freshenVarName(x);
                        return discard2(modify_(insert(x)(y)))(function () {
                            return pure3(y);
                        });
                    };
                    if (v instanceof Data_Maybe.Just) {
                        return pure3(v.value0);
                    };
                    throw new Error("Failed pattern match at Foliage.Program (line 400, column 5 - line 407, column 15): " + [ v.constructor.name ]);
                });
            };
            return Data_Function.flip(Control_Monad_State.evalState)(Data_Map_Internal.empty)(traverse7(f)(t));
        };
    };
};
var substTerm = function (v) {
    return function (v1) {
        if (v1 instanceof VarTerm) {
            return Data_Maybe.fromMaybe(new VarTerm(v1.value0))(lookup2(v1.value0)(v));
        };
        if (v1 instanceof LiteralTerm) {
            return new LiteralTerm(v1.value0, v1.value1);
        };
        if (v1 instanceof UnitTerm) {
            return UnitTerm.value;
        };
        if (v1 instanceof LeftTerm) {
            return new LeftTerm(substTerm(v)(v1.value0));
        };
        if (v1 instanceof RightTerm) {
            return new RightTerm(substTerm(v)(v1.value0));
        };
        if (v1 instanceof PairTerm) {
            return new PairTerm(substTerm(v)(v1.value0), substTerm(v)(v1.value1));
        };
        if (v1 instanceof SetTerm) {
            return new SetTerm(mapFlipped(v1.value0)(substTerm(v)));
        };
        throw new Error("Failed pattern match at Foliage.Program (line 367, column 1 - line 367, column 39): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var substProp = function (sigma) {
    return function (v) {
        return new Prop(v.value0, substTerm(sigma)(v.value1));
    };
};
var substSideHypothesis = function (sigma) {
    return function (v) {
        return new FunctionSideHypothesis({
            resultVarVarName: v.value0.resultVarVarName,
            functionName: v.value0.functionName,
            args: mapFlipped(v.value0.args)(substTerm(sigma))
        });
    };
};
var substHypothesis = function (sigma) {
    return function (v) {
        return new Hypothesis(substProp(sigma)(v.value0), mapFlipped(v.value1)(substSideHypothesis(sigma)));
    };
};
var substRule = function (sigma) {
    return function (v) {
        return new Rule({
            hypotheses: mapFlipped3(v.value0.hypotheses)(substHypothesis(sigma)),
            conclusion: substProp(sigma)(v.value0.conclusion)
        });
    };
};
var _Eq_SumLatticeTypeOrdering = {
    eq: function (x) {
        return genericEq1(x);
    }
};
var genericEqProduct1 = /* #__PURE__ */ Data_Eq_Generic.genericEqProduct(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(_Eq_SumLatticeTypeOrdering));
var _Eq_Show = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_VarName)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ genericShowArgsProduct(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt)))({
        reflectSymbol: function () {
            return "VarName";
        }
    }))
};
var _Show_Term1 = /* #__PURE__ */ _Show_Term(_Eq_Show);
var genericShow10 = /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_SideHypothesisF)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(argsIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(functionNameIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(resultVarVarNameIsSymbol)(_Eq_Show))(_Show_FixedName))(/* #__PURE__ */ Data_Show.showArray(_Show_Term1)))))({
    reflectSymbol: function () {
        return "FunctionSideHypothesis";
    }
}));
var _Show_PropF1 = /* #__PURE__ */ _Show_PropF(_Eq_Show);
var show4 = /* #__PURE__ */ Data_Show.show(_Show_Term1);
var _Show_SideHypothesis = {
    show: function (x) {
        return genericShow10(x);
    }
};
var genericShow11 = /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_HypothesisF)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(_Show_PropF1))(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(_Show_SideHypothesis))))({
    reflectSymbol: function () {
        return "Hypothesis";
    }
}));
var _Show_Hypothesis = {
    show: function (x) {
        return genericShow11(x);
    }
};
var genericShow12 = /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_RuleF)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(conclusionIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(hypothesesIsSymbol)(/* #__PURE__ */ Data_List_Types.showList(_Show_Hypothesis)))(_Show_PropF1))))({
    reflectSymbol: function () {
        return "Rule";
    }
}));
var _Show_Rule = {
    show: function (x) {
        return genericShow12(x);
    }
};
var genericShow13 = /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_Module)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(dataTypeDefsIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(docIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(functionDefsIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(initialGasIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(latticeTypeDefsIsSymbol)(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ Data_Show.showRecordFieldsCons(relationsIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(rulesIsSymbol)(/* #__PURE__ */ showMap(_Show_Rule)))(/* #__PURE__ */ showMap(_Show_Relation)))(_Show_FixedName))(/* #__PURE__ */ showMap(_Show_LatticeTypeDef)))(Data_Show.showInt))(/* #__PURE__ */ showMap(_Show_FunctionDef)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(/* #__PURE__ */ showMap(_Show_DataTypeDef)))))({
    reflectSymbol: function () {
        return "Module";
    }
}));
var genericShow14 = /* #__PURE__ */ Data_Show_Generic.genericShow(_Generic_RipeRuleF)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(hypothesisIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(rule$primeIsSymbol)(_Show_Rule))(_Show_Hypothesis))))({
    reflectSymbol: function () {
        return "RipeRule";
    }
}));
var _Show_Module = {
    show: function (x) {
        return genericShow13(x);
    }
};
var _Show_RipeRule = {
    show: function (x) {
        return genericShow14(x);
    }
};
var _Eq_SetOrdering = {
    eq: function (x) {
        return genericEq2(x);
    }
};
var genericEqProduct2 = /* #__PURE__ */ Data_Eq_Generic.genericEqProduct(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(_Eq_SetOrdering));
var _Eq_ProductLatticeTypeOrdering = {
    eq: function (x) {
        return genericEq4(x);
    }
};
var genericEqProduct3 = /* #__PURE__ */ Data_Eq_Generic.genericEqProduct(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(_Eq_ProductLatticeTypeOrdering));
var _Eq_FixedName = Data_Eq.eqString;
var genericEqArgument1 = /* #__PURE__ */ Data_Eq_Generic.genericEqArgument(_Eq_FixedName);
var genericEqSum1 = /* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(genericEqArgument1));
var genericEqProduct4 = /* #__PURE__ */ Data_Eq_Generic.genericEqProduct(genericEqArgument1);
var eqMap = /* #__PURE__ */ Data_Map_Internal.eqMap(_Eq_FixedName);
var _Eq_LatticeType = {
    eq: function (x) {
        return genericEq5(genericEqSum1(genericEqSum(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(genericEqProduct1(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(_Eq_LatticeType))(Data_Eq_Generic.genericEqArgument(_Eq_LatticeType)))))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(genericEqProduct3(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(_Eq_LatticeType))(Data_Eq_Generic.genericEqArgument(_Eq_LatticeType)))))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(genericEqProduct2(Data_Eq_Generic.genericEqArgument(_Eq_LatticeType))))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(_Eq_LatticeType)))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(_Eq_LatticeType)))(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(_Eq_LatticeType))))))))))(x);
    }
};
var genericEq7 = /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_LatticeTypeDef)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(_Eq_LatticeType)))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(nameIsSymbol)(Data_Eq.eqString))()(compare_implIsSymbol)(Foliage_Common["_Eq_Opaque"]))))));
var eq1 = /* #__PURE__ */ Data_Eq.eq(_Eq_LatticeType);
var _Eq_LatticeTypeDef = {
    eq: function (x) {
        return genericEq7(x);
    }
};
var _Eq_Relation = {
    eq: function (v) {
        return function (v1) {
            return eq1(v.value0.domain)(v1.value0.domain);
        };
    }
};
var _Eq_DataType = {
    eq: function (x) {
        return genericEq6(genericEqSum(genericEqSum1(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(_Eq_DataType))(Data_Eq_Generic.genericEqArgument(_Eq_DataType))))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(_Eq_DataType))(Data_Eq_Generic.genericEqArgument(_Eq_DataType))))(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(_Eq_DataType)))))))(x);
    }
};
var genericEqArgument2 = /* #__PURE__ */ Data_Eq_Generic.genericEqArgument(_Eq_DataType);
var genericEq8 = /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_DataTypeDef)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(genericEqArgument))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(genericEqArgument2)));
var genericEq9 = /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_FunctionDef)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(outputIsSymbol)(_Eq_DataType))()(nameIsSymbol)(Data_Eq.eqString))()(inputsIsSymbol)(/* #__PURE__ */ Data_Eq.eqArray(/* #__PURE__ */ Data_Tuple.eqTuple(Data_Eq.eqString)(_Eq_DataType))))()(implIsSymbol)(Foliage_Common["_Eq_Opaque"])))));
var genericEqSum2 = /* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ genericEqProduct(genericEqArgument2)));
var eq2 = /* #__PURE__ */ Data_Eq.eq(_Eq_DataType);
var _Eq_DataTypeDef = {
    eq: function (x) {
        return genericEq8(x);
    }
};
var _Eq_FunctionDef = {
    eq: function (x) {
        return genericEq9(x);
    }
};
var _Eq_Term = function (dictEq) {
    var genericEqSum3 = Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(dictEq)));
    return {
        eq: function (x) {
            return genericEq(genericEqSum3(genericEqSum(genericEqSum2(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(_Eq_Term(dictEq))))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(_Eq_Term(dictEq))))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqProduct(Data_Eq_Generic.genericEqArgument(_Eq_Term(dictEq)))(Data_Eq_Generic.genericEqArgument(_Eq_Term(dictEq)))))(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqArray(_Eq_Term(dictEq)))))))))))(x);
        }
    };
};
var genericEq10 = /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_SideHypothesisF)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(resultVarVarNameIsSymbol)(_Eq_VarName))()(functionNameIsSymbol)(_Eq_FixedName))()(argsIsSymbol)(/* #__PURE__ */ Data_Eq.eqArray(/* #__PURE__ */ _Eq_Term(_Eq_VarName)))))));
var _Eq_PropF = function (dictEq) {
    var genericEq15 = genericEq3(Data_Eq_Generic.genericEqConstructor(genericEqProduct4(Data_Eq_Generic.genericEqArgument(_Eq_Term(dictEq)))));
    return {
        eq: function (x) {
            return genericEq15(x);
        }
    };
};
var _Eq_PropF1 = /* #__PURE__ */ _Eq_PropF(_Eq_VarName);
var _Eq_SideHypothesis = {
    eq: function (x) {
        return genericEq10(x);
    }
};
var genericEq11 = /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_HypothesisF)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqProduct(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(_Eq_PropF1))(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqArray(_Eq_SideHypothesis)))));
var _Eq_Hypothesis = {
    eq: function (x) {
        return genericEq11(x);
    }
};
var genericEq12 = /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_RuleF)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(hypothesesIsSymbol)(/* #__PURE__ */ Data_List_Types.eqList(_Eq_Hypothesis)))()(conclusionIsSymbol)(_Eq_PropF1)))));
var _Eq_Rule = {
    eq: function (x) {
        return genericEq12(x);
    }
};
var genericEq13 = /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_Module)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(rulesIsSymbol)(/* #__PURE__ */ eqMap(_Eq_Rule)))()(relationsIsSymbol)(/* #__PURE__ */ eqMap(_Eq_Relation)))()(nameIsSymbol)(_Eq_FixedName))()(latticeTypeDefsIsSymbol)(/* #__PURE__ */ eqMap(_Eq_LatticeTypeDef)))()(initialGasIsSymbol)(Data_Eq.eqInt))()(functionDefsIsSymbol)(/* #__PURE__ */ eqMap(_Eq_FunctionDef)))()(docIsSymbol)(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString)))()(dataTypeDefsIsSymbol)(/* #__PURE__ */ eqMap(_Eq_DataTypeDef))))));
var genericEq14 = /* #__PURE__ */ Data_Eq_Generic.genericEq(_Generic_RipeRuleF)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(rule$primeIsSymbol)(_Eq_Rule))()(hypothesisIsSymbol)(_Eq_Hypothesis)))));
var _Eq_Module = {
    eq: function (x) {
        return genericEq13(x);
    }
};
var _Eq_RipeRule = {
    eq: function (x) {
        return genericEq14(x);
    }
};
var getValidatedArg = function (v) {
    return function (args) {
        return bindFlipped(function (v1) {
            if (v1 instanceof LiteralTerm && eq2(v.dt)(v1.value1)) {
                return Data_Maybe.maybe(throwExternalFunctionCallError(v.f)(v1.value0 + (" is not a " + v.dt_name)))(pure4)(v.fromString(v1.value0));
            };
            return throwExternalFunctionCallError(v.f)("expected arg " + (v.x + (" = " + (show4(v1) + (" to be a " + v.dt_name)))));
        })(Data_Maybe.maybe(throwExternalFunctionCallError(v.f)("no arg for " + show1(v.x)))(pure4)(lookup(v.x)(args)));
    };
};
export {
    render,
    lookupModule,
    Module,
    ExternalDataTypeDef,
    DataTypeDef,
    UnitDataType,
    NamedDataType,
    SumDataType,
    ProductDataType,
    SetDataType,
    LatticeTypeDef,
    ExternalLatticeTypeDef,
    NamedLatticeType,
    UnitLatticeType,
    SumLatticeType,
    ProductLatticeType,
    SetLatticeType,
    OppositeLatticeType,
    FlatLatticeType,
    PowerLatticeType,
    LeftGreaterThanRight_SumLatticeTypeOrdering,
    LeftLessThanRight_SumLatticeTypeOrdering,
    LeftIncomparableRight_SumLatticeTypeOrdering,
    LeftEqualRight_SumLatticeTypeOrdering,
    FirstThenSecond_ProductLatticeTypeOrdering,
    SetOrdering,
    ExternalFunctionDef,
    Relation,
    Rule,
    RipeRule,
    from_RipeRule_to_Rule,
    fromNoHypothesesRule,
    nextHypothesis,
    Hypothesis,
    substHypothesis,
    FunctionSideHypothesis,
    substSideHypothesis,
    Prop,
    VarTerm,
    UnitTerm,
    LiteralTerm,
    LeftTerm,
    RightTerm,
    PairTerm,
    SetTerm,
    substRule,
    substProp,
    substTerm,
    freshVarNameIndexRef,
    freshenVarName,
    freshenVarNames,
    VarName,
    newVarName,
    FixedName,
    mainModuleName,
    getValidatedArg,
    throwExternalFunctionCallError,
    RenderCtx,
    append_render,
    divs,
    doc_block,
    definition,
    line,
    Punc,
    Prim,
    section,
    Raw,
    Lit,
    _Generic_Module,
    _Eq_Module,
    _Show_Module,
    _Generic_DataTypeDef,
    _Eq_DataTypeDef,
    _Show_DataTypeDef,
    _Generic_DataType,
    _Eq_DataType,
    _Show_DataType,
    _Generic_LatticeTypeDef,
    _Eq_LatticeTypeDef,
    _Show_LatticeTypeDef,
    _Generic_LatticeType,
    _Eq_LatticeType,
    _Show_LatticeType,
    _Generic_SumLatticeTypeOrdering,
    _Eq_SumLatticeTypeOrdering,
    _Show_SumLatticeTypeOrdering,
    _Generic_ProductLatticeTypeOrdering,
    _Eq_ProductLatticeTypeOrdering,
    _Show_ProductLatticeTypeOrdering,
    _Generic_SetOrdering,
    _Eq_SetOrdering,
    _Show_SetOrdering,
    _Generic_FunctionDef,
    _Eq_FunctionDef,
    _Show_FunctionDef,
    _Generic_Relation,
    _Eq_Relation,
    _Show_Relation,
    _Generic_RuleF,
    _Functor_RuleF,
    _Foldable_RuleF,
    _Traversable_RuleF,
    _Eq_Rule,
    _Show_Rule,
    _Generic_RipeRuleF,
    _Functor_RipeRuleF,
    _Foldable_RipeRuleF,
    _Traversable_RipeRuleF,
    _Eq_RipeRule,
    _Show_RipeRule,
    _Generic_HypothesisF,
    _Functor_HypothesisF,
    _Foldable_HypothesisF,
    _Traversable_HypothesisF,
    _Eq_Hypothesis,
    _Show_Hypothesis,
    _Generic_SideHypothesisF,
    _Functor_SideHypothesisF,
    _Foldable_SideHypothesisF,
    _Traversable_SideHypothesisF,
    _Eq_SideHypothesis,
    _Show_SideHypothesis,
    _Generic_PropF,
    _Functor_PropF,
    _Foldable_PropF,
    _Traversable_PropF,
    _Eq_PropF,
    _Show_PropF,
    _Generic_TermF,
    _Functor_TermF,
    _Foldable_TermF,
    _Traversable_TermF,
    _Eq_Term,
    _Show_Term,
    _Generic_VarName,
    _Eq_VarName,
    _Ord_VarName,
    _Eq_Show,
    _Newtype_FixedName,
    _Eq_FixedName,
    _Ord_FixedName,
    _Show_FixedName,
    _Render_Htmls,
    _Render_RenderM_Htmls,
    _Render_Module,
    _Render_Rule,
    _Render_LatticeType,
    _Render_DataType,
    _Render_TermSubst,
    _Render_Punc,
    _Render_Prim,
    _Render_VarName,
    _Render_FixedName,
    _Render_Hypothesis,
    _Render_SideHypothesis,
    _Render_Prop,
    _Render_Term,
    _Render_Raw,
    _Render_Lit
};
